import { RouteObject } from "react-router-dom";
import { InlineApp } from "./InlineApp";
import { InlineMap } from "./InlineMap";
import InlineNotificationDetail from "./InlineNotificationDetail";
import InlineNotificationList from "./InlineNotificationList";
import { InlineRuleForm } from "./InlineRuleForm";
import { InlineRuleDetail } from "./InlineRuleDetail";
import { InlineRulesList } from "./InlineRulesList";

export const InlineUrls: RouteObject[] = [{
    index: true,
    element: <InlineApp />,
},
{
    path: "rules",
    element: <InlineRulesList />
},
{
    path: "rules/new",
    element: <InlineRuleForm />
},
{
    path: "rules/:ruleId",
    element: <InlineRuleDetail />
},
{
    path: "rules/:ruleId/edit",
    element: <InlineRuleForm />
},
{
    path: "map",
    element: <InlineMap />
},
{
    path: "notifications",
    element: <InlineNotificationList />
},
{
    path: "notifications/:notificationId",
    element: <InlineNotificationDetail />
}];
